"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UseUpgradeRequested = exports.Name = void 0;
const Name = exports.Name = 'user-upgrade-requested';
const UseUpgradeRequested = exports.UseUpgradeRequested = Name;
